import { lazy } from 'react';
import * as routePath from '../route-path';
import * as routeName from '../route-name';
import { t } from 'utilities/lang';

export const Creatives = lazy(() =>
  import('components/Pages/Library/components/Creatives')
);

export const UploadCreatives = lazy(() =>
  import(
    'components/Pages/Library/components/Creatives/components/UploadCreatives'
  )
);

const AudienceDetail = lazy(() => import('components/Pages/AudienceDetail'));

// const PurchasedTemplate = lazy(() =>
//   import('components/Pages/Library/components/Templates')
// );

// const TemplateDetail = lazy(() => import('components/Pages/TemplateDetail'));

export const libraryRoutes = [
  {
    path: routePath.AUDIENCE_DETAIL,
    component: AudienceDetail,
    exact: true,
    parentName: routeName.MY_LIBRARY,
    breadcrumbs: [
      { name: routeName.LIBRARY },
      { name: routeName.AUDIENCES, link: routePath.AUDIENCES },
      { name: t('route.view_details') },
    ],
  },
  // // Templates
  // {
  //   path: routePath.PURCHASED_TEMPLATE,
  //   component: PurchasedTemplate,
  //   name: routeName.PURCHASED_TEMPLATE,
  //   breadcrumbs: [
  //     { name: routeName.LIBRARY },
  //     { name: routeName.PURCHASED_TEMPLATE },
  //   ],
  //   exact: true,
  //   showMenu: true,
  // },
  // {
  //   path: routePath.PURCHASED_TEMPLATE_DETAIL,
  //   component: TemplateDetail,
  //   exact: true,
  //   parentName: routeName.PURCHASED_TEMPLATE,
  //   showOnly: true,
  //   breadcrumbs: [{ name: routeName.LIBRARY }, { name: 'View Detail' }],
  // },
];
